export const usersData = [
    {
      id: 1,
      firstName: "Ravi",
      lastName: "Navapara",
      email: "ukglobalsolution@gmail.com",
      phone: "+91 7698537198",
      profile: "https://i.pravatar.cc/150?img=3",
      country: "India",
      relation: "Self",
      age: 25,
      profession: "Software Engineer",
      createdAt: "2024-01-15",
      referralCode: "REF001",
      referredBy: "John Smith",
      benefitFromCoaching: "To improve leadership skills and personal growth",
      coachingInterests: ["Leadership", "Communication", "Time Management"],
      coachingKnowledge: ["Intermediate", "Advanced", "Expert"],
    },
    {
      id: 2,
      firstName: "Krish",
      lastName: "Patel",
      email: "krispatel2323@gmail.com",
      phone: "+91 9664865935",
      profile: "https://i.pravatar.cc/150?img=5",
      country: "USA",
      relation: "Self",
      age: 25,
      profession: "Software Engineer",
      createdAt: "2024-01-15",
      referralCode: "REF001",
      referredBy: "Sarah Johnson",
      benefitFromCoaching: "To improve leadership skills and personal growth",
      coachingInterests: ["Leadership", "Communication", "Time Management"],
      coachingKnowledge: ["Intermediate", "Advanced", "Expert"],
    },
    {
      id: 3,
      firstName: "Dhruv",
      lastName: "Patel",
      email: "cubes.dev10@gmail.com",
      phone: "+91 7359420757",
      profile: "https://i.pravatar.cc/150?img=8",
      country: "UK",
      relation: "Self",
      age: 25,
      profession: "Software Engineer",
      createdAt: "2024-01-15",
      referralCode: "REF001",
      referredBy: "Michael Brown",
      benefitFromCoaching: "To improve leadership skills and personal growth",
      coachingInterests: ["Leadership", "Communication", "Time Management"],
      coachingKnowledge: ["Intermediate", "Advanced", "Expert"],
    },
    {
      id: 4,
      firstName: "Dhruv",
      lastName: "Patel",
      email: "cubes.dev10@gmail.com",
      phone: "+91 7359420757",
      profile: "https://i.pravatar.cc/150?img=8",
      country: "India",
      relation: "Self",
      age: 25,
      profession: "Software Engineer",
      createdAt: "2024-01-15",
      referralCode: "REF001",
      referredBy: "Emily Davis",
      benefitFromCoaching: "To improve leadership skills and personal growth",
      coachingInterests: ["Leadership", "Communication", "Time Management"],
      coachingKnowledge: ["Intermediate", "Advanced", "Expert"],
    },
    {
      id: 5,
      firstName: "Dhruv",
      lastName: "Patel",
      email: "cubes.dev10@gmail.com",
      phone: "+91 7359420757",
      profile: "https://i.pravatar.cc/150?img=8",
      country: "Canada",
      relation: "Self",
      age: 25,
      profession: "Software Engineer",
      createdAt: "2024-01-15",
      referralCode: "REF001",
      referredBy: "David Wilson",
      benefitFromCoaching: "To improve leadership skills and personal growth",
      coachingInterests: ["Leadership", "Communication", "Time Management"],
      coachingKnowledge: ["Intermediate", "Advanced", "Expert"],
    },
    {
      id: 6,
      firstName: "Dhruv",
      lastName: "Patel",
      email: "cubes.dev10@gmail.com",
      phone: "+91 7359420757",
      profile: "https://i.pravatar.cc/150?img=8",
      country: "Australia",
      relation: "Self",
      age: 25,
      profession: "Software Engineer",
      createdAt: "2024-01-15",
      referralCode: "REF001",
      referredBy: "Lisa Anderson",
      benefitFromCoaching: "To improve leadership skills and personal growth",
      coachingInterests: ["Leadership", "Communication", "Time Management"],
      coachingKnowledge: ["Intermediate", "Advanced", "Expert"],
    },
    {
      id: 7,
      firstName: "Dhruv",
      lastName: "Patel",
      email: "cubes.dev10@gmail.com",
      phone: "+91 7359420757",
      profile: "https://i.pravatar.cc/150?img=8",
      country: "India",
      relation: "Self",
      age: 25,
      profession: "Software Engineer",
      createdAt: "2024-01-15",
      referralCode: "REF001",
      referredBy: "Robert Taylor",
      benefitFromCoaching: "To improve leadership skills and personal growth",
      coachingInterests: ["Leadership", "Communication", "Time Management"],
      coachingKnowledge: ["Intermediate", "Advanced", "Expert"],
    },
    {
        id: 8,
        firstName: "Krish",
        lastName: "Patel",
        email: "krispatel2323@gmail.com",
        phone: "+91 9664865935",
        profile: "https://i.pravatar.cc/150?img=5",
        country: "USA",
        relation: "Self",
        age: 25,
        profession: "Software Engineer",
        createdAt: "2024-01-15",
        referralCode: "REF001",
        referredBy: "Jennifer Martinez",
        benefitFromCoaching: "To improve leadership skills and personal growth",
        coachingInterests: ["Leadership", "Communication", "Time Management"],
        coachingKnowledge: ["Intermediate", "Advanced", "Expert"],
      },
      {
        id: 9,
        firstName: "Krish",
        lastName: "Patel",
        email: "krispatel2323@gmail.com",
        phone: "+91 9664865935",
        profile: "https://i.pravatar.cc/150?img=5",
        country: "USA",
        relation: "Self",
        age: 25,
        profession: "Software Engineer",
        createdAt: "2024-01-15",
        referralCode: "REF001",
        referredBy: "James White",
        benefitFromCoaching: "To improve leadership skills and personal growth",
        coachingInterests: ["Leadership", "Communication", "Time Management"],
        coachingKnowledge: ["Intermediate", "Advanced", "Expert"],
      },
      {
        id: 10,
        firstName: "Krish",
        lastName: "Patel",
        email: "krispatel2323@gmail.com",
        phone: "+91 9664865935",
        profile: "https://i.pravatar.cc/150?img=5",
        country: "USA",
        relation: "Self",
        age: 25,
        profession: "Software Engineer",
        createdAt: "2024-01-15",
        referralCode: "REF001",
        referredBy: "Maria Garcia",
        benefitFromCoaching: "To improve leadership skills and personal growth",
        coachingInterests: ["Leadership", "Communication", "Time Management"],
        coachingKnowledge: ["Intermediate", "Advanced", "Expert"],
      },
      {
        id: 11,
        firstName: "Krish",
        lastName: "Patel",
        email: "krispatel2323@gmail.com",
        phone: "+91 9664865935",
        profile: "https://i.pravatar.cc/150?img=5",
        country: "USA",
        relation: "Self",
        age: 25,
        profession: "Software Engineer",
        createdAt: "2024-01-15",
        referralCode: "REF001",
        referredBy: "Christopher Lee",
            benefitFromCoaching: "To improve leadership skills and personal growth",
        coachingInterests: ["Leadership", "Communication", "Time Management"],
        coachingKnowledge: ["Intermediate", "Advanced", "Expert"],
      },
      {
          id: 12,
        firstName: "Krish",
        lastName: "Patel",
        email: "krispatel2323@gmail.com",
        phone: "+91 9664865935",
        profile: "https://i.pravatar.cc/150?img=5",
        country: "USA",
        relation: "Self",
        age: 25,
        profession: "Software Engineer",
        createdAt: "2024-01-15",
        referralCode: "REF001",
        referredBy: "Amanda Harris",
        benefitFromCoaching: "To improve leadership skills and personal growth",
        coachingInterests: ["Leadership", "Communication", "Time Management"],
        coachingKnowledge: ["Intermediate", "Advanced", "Expert"],
      },
      {
        id: 13,
        firstName: "Krish",
        lastName: "Patel",
        email: "krispatel2323@gmail.com",
        phone: "+91 9664865935",
        profile: "https://i.pravatar.cc/150?img=5",
        country: "USA",
        relation: "Self",
        age: 25,
        profession: "Software Engineer",
        createdAt: "2024-01-15",
        referralCode: "REF001",
        referredBy: "Daniel Clark",
        benefitFromCoaching: "To improve leadership skills and personal growth",
        coachingInterests: ["Leadership", "Communication", "Time Management"],
        coachingKnowledge: ["Intermediate", "Advanced", "Expert"],
      },
      {
        id: 14,
        firstName: "Krish",
        lastName: "Patel",
        email: "krispatel2323@gmail.com",
        phone: "+91 9664865935",
        profile: "https://i.pravatar.cc/150?img=5",
        country: "USA",
        relation: "Self",
        age: 25,
        profession: "Software Engineer",
        createdAt: "2024-01-15",
        referralCode: "REF001",
        referredBy: "Jessica Thompson",
        benefitFromCoaching: "To improve leadership skills and personal growth",
        coachingInterests: ["Leadership", "Communication", "Time Management"],
        coachingKnowledge: ["Intermediate", "Advanced", "Expert"],
      },
      {
        id: 15,
        firstName: "Krish",
        lastName: "Patel",
        email: "krispatel2323@gmail.com",
        phone: "+91 9664865935",
        profile: "https://i.pravatar.cc/150?img=5",
        country: "USA",
        relation: "Self",
        age: 25,
        profession: "Software Engineer",
        createdAt: "2024-01-15",
        referralCode: "REF001",
        referredBy: "Matthew Lewis",
        benefitFromCoaching: "To improve leadership skills and personal growth",
        coachingInterests: ["Leadership", "Communication", "Time Management"],
        coachingKnowledge: ["Intermediate", "Advanced", "Expert"],
      },
      
  ];

export const coachData = [
  {
    id: 1,
    firstName: "John",
    lastName: "Smith",
    phone: "+1 555-0123",
    profile: "https://i.pravatar.cc/150?img=12",
    country: "USA",
    city: "New York",
    professionalBackground: "Experienced life coach with over 15 years of helping individuals achieve their personal and professional goals. Specialized in career development, relationship coaching, and personal growth.",
    coachingSince: "2010-01-01",
    createdAt: "2009-12-15",
    languages: ["English", "Spanish","Hindi","French"],
    coachingSpecialities: ["Life Coaching", "Career Development", "Relationship Coaching"],
    coachingAccreditation: ["ICF - ACC", "ICF - PCC", "APECS Accredited Executive Coach"],
    coachingInstitute: "International Coach Federation (ICF) - Advanced Coaching Program",
    certificate: "https://example.com/certificates/john-smith-icf-certificate.pdf",
    currency: "USD",
    minimumRate: 100,
    maximumRate: 200,
    availability: {
      monday: { available: true, timeSlots: ["9:00 am - 12:00 pm", "2:00 pm - 5:00 pm", "6:00 pm - 8:00 pm"] },
      tuesday: { available: false, timeSlots: [] },
      wednesday: { available: true, timeSlots: ["10:00 am - 1:00 pm", "3:00 pm - 7:00 pm"] },
      thursday: { available: true, timeSlots: ["11:00 am - 2:00 pm"] },
      friday: { available: true, timeSlots: ["9:00 am - 12:00 pm", "2:00 pm - 6:00 pm"] },
      saturday: { available: true, timeSlots: ["10:00 am - 2:00 pm"] },
      sunday: { available: false, timeSlots: [] },
    },
  },
  {
    id: 2,
    firstName: "Sarah",
    lastName: "Johnson",
    phone: "+1 555-0124",
    profile: "https://i.pravatar.cc/150?img=13",
    country: "UK",
    city: "London",
    professionalBackground: "Certified executive coach with expertise in leadership development and organizational transformation.",
    coachingSince: "2015-03-15",
    createdAt: "2015-02-20",
    languages: ["English", "Spanish","Hindi","French"], 
    coachingSpecialities: ["Executive Coaching", "Leadership Development"],
    coachingAccreditation: ["ICF - PCC", "APECS Accredited Executive Team Coach"],
    coachingInstitute: "European Mentoring and Coaching Council (EMCC) - Executive Coaching Certification",
    certificate: "https://example.com/certificates/sarah-johnson-emcc-certificate.pdf",
    currency: "GBP",
    minimumRate: 80,
    maximumRate: 150,
    availability: {
      monday: { available: true, timeSlots: ["9:00 am - 12:00 pm", "1:00 pm - 6:00 pm"] },
      tuesday: { available: true, timeSlots: ["9:00 am - 11:00 am", "2:00 pm - 6:00 pm"] },
      wednesday: { available: true, timeSlots: ["9:00 am - 6:00 pm"] },
      thursday: { available: true, timeSlots: ["10:00 am - 1:00 pm", "3:00 pm - 6:00 pm"] },
      friday: { available: true, timeSlots: ["9:00 am - 12:00 pm", "1:00 pm - 5:00 pm"] },
      saturday: { available: false, timeSlots: [] },
      sunday: { available: false, timeSlots: [] },
    },
  },
  {
    id: 3,
    firstName: "Michael",
    lastName: "Brown",
    phone: "+1 555-0125",
    profile: "https://i.pravatar.cc/150?img=14",
    country: "Canada",
    city: "Toronto",
    professionalBackground: "Business coach specializing in entrepreneurship and startup growth strategies.",
    coachingSince: "2012-06-01",
    createdAt: "2012-05-10",
    languages: ["English", "Spanish","Hindi","French"], 
    coachingSpecialities: ["Business Coaching", "Entrepreneurship"],
    coachingAccreditation: ["ICF - MCC", "EMCC - EIA"],
    coachingInstitute: "Coaching Academy International - Business Coaching Program",
    certificate: "https://example.com/certificates/michael-brown-certificate.pdf",
    currency: "CAD",
    minimumRate: 120,
    maximumRate: 250,
    availability: {
      monday: { available: true, timeSlots: ["8:00 am - 11:00 am", "1:00 pm - 5:00 pm"] },
      tuesday: { available: true, timeSlots: ["8:00 am - 10:00 am", "11:00 am - 2:00 pm", "3:00 pm - 5:00 pm"] },
      wednesday: { available: false, timeSlots: [] },
      thursday: { available: true, timeSlots: ["8:00 am - 12:00 pm", "2:00 pm - 5:00 pm"] },
      friday: { available: true, timeSlots: ["8:00 am - 5:00 pm"] },
      saturday: { available: true, timeSlots: ["10:00 am - 1:00 pm", "2:00 pm - 4:00 pm"] },
      sunday: { available: false, timeSlots: [] },
    },
  },
  {
    id: 4,
    firstName: "Emily",
    lastName: "Davis",
    phone: "+1 555-0126",
    profile: "https://i.pravatar.cc/150?img=15",
    country: "Australia",
    city: "Sydney",
    professionalBackground: "Wellness and mindfulness coach helping clients achieve work-life balance.",
    coachingSince: "2018-09-10",
    createdAt: "2018-08-25",
    languages: ["English", "Spanish","Hindi","French"], 
    coachingSpecialities: ["Wellness Coaching", "Mindfulness"],
    coachingAccreditation: ["ICF - ACC", "APECS Fellow"],
    coachingInstitute: "Wellness Coaching Institute - Mindfulness and Wellness Program",
    certificate: "https://example.com/certificates/emily-davis-certificate.pdf",
    currency: "AUD",
    minimumRate: 90,
    maximumRate: 180,
    availability: {
      monday: { available: false, timeSlots: [] },
      tuesday: { available: true, timeSlots: ["11:00 am - 2:00 pm", "3:00 pm - 6:00 pm", "7:00 pm - 8:00 pm"] },
      wednesday: { available: true, timeSlots: ["11:00 am - 1:00 pm", "2:00 pm - 5:00 pm", "6:00 pm - 8:00 pm"] },
      thursday: { available: true, timeSlots: ["11:00 am - 3:00 pm", "4:00 pm - 8:00 pm"] },
      friday: { available: true, timeSlots: ["11:00 am - 2:00 pm", "3:00 pm - 8:00 pm"] },
      saturday: { available: true, timeSlots: ["10:00 am - 1:00 pm", "2:00 pm - 4:00 pm"] },
      sunday: { available: false, timeSlots: [] },
    },
  },
  {
    id: 5,
    firstName: "David",
    lastName: "Wilson",
    phone: "+1 555-0127",
    profile: "https://i.pravatar.cc/150?img=16",
    country: "USA",
    city: "Los Angeles",
    professionalBackground: "Career transition coach with expertise in helping professionals navigate career changes.",
    coachingSince: "2016-04-20",
    createdAt: "2016-03-30",
    languages: ["English", "Spanish","Hindi","French"], 
    coachingSpecialities: ["Career Coaching", "Transition Coaching"],
    coachingAccreditation: ["ICF - ACC", "AC - Coach"],
    coachingInstitute: "Career Coaching Institute - Career Transition Program",
    certificate: "https://example.com/certificates/david-wilson-certificate.pdf",
    currency: "USD",
    minimumRate: 110,
    maximumRate: 220,
    availability: {
      monday: { available: true, timeSlots: ["10:00 am - 7:00 pm", "2:00 pm - 5:00 pm"] },
      tuesday: { available: true, timeSlots: ["10:00 am - 7:00 pm"] },
      wednesday: { available: true, timeSlots: ["10:00 am - 7:00 pm"] },
      thursday: { available: false, timeSlots: [] },
      friday: { available: true, timeSlots: ["10:00 am - 7:00 pm"] },
      saturday: { available: false, timeSlots: [] },
      sunday: { available: false, timeSlots: [] },
    },
  },
  {
    id: 6,
    firstName: "Lisa",
    lastName: "Anderson",
    phone: "+1 555-0128",
    profile: "https://i.pravatar.cc/150?img=17",
    country: "UK",
    city: "Manchester",
    professionalBackground: "Performance coach focused on helping athletes and professionals reach peak performance.",
    coachingSince: "2014-07-05",
    createdAt: "2014-06-15",
    languages: ["English", "Spanish","Hindi","French"], 
    coachingSpecialities: ["Performance Coaching", "Sports Coaching"],
    coachingAccreditation: ["ICF - PCC", "EMCC - ESIA"],
    coachingInstitute: "Performance Coaching Academy - Sports and Performance Program",
    certificate: "https://example.com/certificates/lisa-anderson-certificate.pdf",
    currency: "GBP",
    minimumRate: 95,
    maximumRate: 190,
    availability: {
      monday: { available: true, timeSlots: ["9:00 am - 6:00 pm"] },
      tuesday: { available: false, timeSlots: [] },
      wednesday: { available: true, timeSlots: ["9:00 am - 6:00 pm"] },
      thursday: { available: true, timeSlots: ["9:00 am - 6:00 pm"] },
      friday: { available: true, timeSlots: ["9:00 am - 6:00 pm"] },
      saturday: { available: true, timeSlots: ["10:00 am - 3:00 pm"] },
      sunday: { available: false, timeSlots: [] },
    },
  },
  {
    id: 7,
    firstName: "Robert",
    lastName: "Taylor",
    phone: "+1 555-0129",
    profile: "https://i.pravatar.cc/150?img=18",
    country: "Canada",
    city: "Vancouver",
    professionalBackground: "Team coaching specialist working with organizations to build high-performing teams.",
    coachingSince: "2017-11-12",
    createdAt: "2017-10-20",
    languages: ["English", "Spanish","Hindi","French"], 
    coachingSpecialities: ["Team Coaching", "Organizational Coaching"],
    coachingAccreditation: ["APECS Accredited Executive Team Coach", "EMCC - ESQA"],
    coachingInstitute: "Team Coaching Institute - Organizational Team Development Program",
    certificate: "https://example.com/certificates/robert-taylor-certificate.pdf",
    currency: "CAD",
    minimumRate: 130,
    maximumRate: 260,
    availability: {
      monday: { available: true, timeSlots: ["8:00 am - 6:00 pm"] },
      tuesday: { available: true, timeSlots: ["8:00 am - 6:00 pm"] },
      wednesday: { available: true, timeSlots: ["8:00 am - 6:00 pm"] },
      thursday: { available: true, timeSlots: ["8:00 am - 6:00 pm"] },
      friday: { available: true, timeSlots: ["8:00 am - 4:00 pm"] },
      saturday: { available: false, timeSlots: [] },
      sunday: { available: false, timeSlots: [] },
    },
  },
  {
    id: 8,
    firstName: "Jennifer",
    lastName: "Martinez",
    phone: "+1 555-0130",
    profile: "https://i.pravatar.cc/150?img=19",
    country: "USA",
    city: "Chicago",
    professionalBackground: "Transformational coach helping individuals unlock their full potential.",
    coachingSince: "2013-02-28",
    createdAt: "2013-02-10",
    languages: ["English", "Spanish","Hindi","French"], 
    coachingSpecialities: ["Transformational Coaching", "Personal Development"],
    coachingAccreditation: ["ICF - PCC", "EMCC - EQA"],
    coachingInstitute: "Transformational Coaching Academy - Advanced Coaching Program",
    certificate: "https://example.com/certificates/jennifer-martinez-certificate.pdf",
    currency: "USD",
    minimumRate: 100,
    maximumRate: 200,
    availability: {
      monday: { available: true, timeSlots: ["10:00 am - 7:00 pm"] },
      tuesday: { available: false, timeSlots: [] },
      wednesday: { available: true, timeSlots: ["10:00 am - 7:00 pm"] },
      thursday: { available: false, timeSlots: [] },
      friday: { available: true, timeSlots: ["10:00 am - 7:00 pm"] },
      saturday: { available: false, timeSlots: [] },
      sunday: { available: false, timeSlots: [] },
    },
  },
  {
    id: 9,
    firstName: "Jennifer",
    lastName: "Martinez",
    phone: "+1 555-0130",
    profile: "https://i.pravatar.cc/150?img=19",
    country: "USA",
    city: "Chicago",
    professionalBackground: "Transformational coach helping individuals unlock their full potential.",
    coachingSince: "2013-02-28",
    createdAt: "2013-02-10",
    languages: ["English", "Spanish","Hindi","French"], 
    coachingSpecialities: ["Transformational Coaching", "Personal Development"],
    coachingAccreditation: ["ICF - PCC", "EMCC - EQA"],
    coachingInstitute: "Transformational Coaching Academy - Advanced Coaching Program",
    certificate: "https://example.com/certificates/jennifer-martinez-certificate.pdf",
    currency: "USD",
    minimumRate: 100,
    maximumRate: 200,
    availability: {
      monday: { available: true, timeSlots: ["10:00 am - 7:00 pm"] },
      tuesday: { available: false, timeSlots: [] },
      wednesday: { available: true, timeSlots: ["10:00 am - 7:00 pm"] },
      thursday: { available: false, timeSlots: [] },
      friday: { available: true, timeSlots: ["10:00 am - 7:00 pm"] },
      saturday: { available: false, timeSlots: [] },
      sunday: { available: false, timeSlots: [] },
    },
  },
  {
    id: 10,
    firstName: "Jennifer",
    lastName: "Martinez",
    phone: "+1 555-0130",
    profile: "https://i.pravatar.cc/150?img=19",
    country: "USA",
    city: "Chicago",
    professionalBackground: "Transformational coach helping individuals unlock their full potential.",
    coachingSince: "2013-02-28",
    createdAt: "2013-02-10",
    languages: ["English", "Spanish","Hindi","French"], 
    coachingSpecialities: ["Transformational Coaching", "Personal Development"],
    coachingAccreditation: ["ICF - PCC", "EMCC - EQA"],
    coachingInstitute: "Transformational Coaching Academy - Advanced Coaching Program",
    certificate: "https://example.com/certificates/jennifer-martinez-certificate.pdf",
    currency: "USD",
    minimumRate: 100,
    maximumRate: 200,
    availability: {
      monday: { available: true, timeSlots: ["10:00 am - 7:00 pm"] },
      tuesday: { available: false, timeSlots: [] },
      wednesday: { available: true, timeSlots: ["10:00 am - 7:00 pm"] },
      thursday: { available: false, timeSlots: [] },
      friday: { available: true, timeSlots: ["10:00 am - 7:00 pm"] },
      saturday: { available: false, timeSlots: [] },
      sunday: { available: false, timeSlots: [] },
    },
  },
  {
    id: 11,
    firstName: "Jennifer",
    lastName: "Martinez",
    phone: "+1 555-0130",
    profile: "https://i.pravatar.cc/150?img=19",
    country: "USA",
    city: "Chicago",
    professionalBackground: "Transformational coach helping individuals unlock their full potential.",
    coachingSince: "2013-02-28",
    createdAt: "2013-02-10",
    languages: ["English", "Spanish","Hindi","French"], 
    coachingSpecialities: ["Transformational Coaching", "Personal Development"],
    coachingAccreditation: ["ICF - PCC", "EMCC - EQA"],
    coachingInstitute: "Transformational Coaching Academy - Advanced Coaching Program",
    certificate: "https://example.com/certificates/jennifer-martinez-certificate.pdf",
    currency: "USD",
    minimumRate: 100,
    maximumRate: 200,
    availability: {
      monday: { available: true, timeSlots: ["10:00 am - 7:00 pm"] },
      tuesday: { available: false, timeSlots: [] },
      wednesday: { available: true, timeSlots: ["10:00 am - 7:00 pm"] },
      thursday: { available: false, timeSlots: [] },
      friday: { available: true, timeSlots: ["10:00 am - 7:00 pm"] },
      saturday: { available: false, timeSlots: [] },
      sunday: { available: false, timeSlots: [] },
    },
  },
  {
    id: 12,
    firstName: "Jennifer",
    lastName: "Martinez",
    phone: "+1 555-0130",
    profile: "https://i.pravatar.cc/150?img=19",
    country: "USA",
    city: "Chicago",
    professionalBackground: "Transformational coach helping individuals unlock their full potential.",
    coachingSince: "2013-02-28",
    createdAt: "2013-02-10",
    languages: ["English", "Spanish","Hindi","French"],   
    coachingSpecialities: ["Transformational Coaching", "Personal Development"],
    coachingAccreditation: ["ICF - PCC", "EMCC - EQA"],
    coachingInstitute: "Transformational Coaching Academy - Advanced Coaching Program",
    certificate: "https://example.com/certificates/jennifer-martinez-certificate.pdf",
    currency: "USD",
    minimumRate: 100,
    maximumRate: 200,
    availability: {
      monday: { available: true, timeSlots: ["10:00 am - 7:00 pm"] },
      tuesday: { available: false, timeSlots: [] },
      wednesday: { available: true, timeSlots: ["10:00 am - 7:00 pm"] },
      thursday: { available: false, timeSlots: [] },
      friday: { available: true, timeSlots: ["10:00 am - 7:00 pm"] },
      saturday: { available: false, timeSlots: [] },
      sunday: { available: false, timeSlots: [] },
    },
  },
  {
    id: 13,
    firstName: "Jennifer",
    lastName: "Martinez",
    phone: "+1 555-0130",
    profile: "https://i.pravatar.cc/150?img=19",
    country: "USA",
    city: "Chicago",
    professionalBackground: "Transformational coach helping individuals unlock their full potential.",
    coachingSince: "2013-02-28",
    createdAt: "2013-02-10",
    languages: ["English", "Spanish","Hindi","French"],   
    coachingSpecialities: ["Transformational Coaching", "Personal Development"],
    coachingAccreditation: ["ICF - PCC", "EMCC - EQA"],
    coachingInstitute: "Transformational Coaching Academy - Advanced Coaching Program",
    trainingHours: "Completed 250+ hours of transformational coaching training including personal development, mindset shifts, and goal achievement.",
    certificate: "https://example.com/certificates/jennifer-martinez-certificate.pdf",
    currency: "USD",
    minimumRate: 100,
    maximumRate: 200,
    availability: {
      monday: { available: true, timeSlots: ["10:00 am - 7:00 pm"] },
      tuesday: { available: false, timeSlots: [] },
      wednesday: { available: true, timeSlots: ["10:00 am - 7:00 pm"] },
      thursday: { available: false, timeSlots: [] },
      friday: { available: true, timeSlots: ["10:00 am - 7:00 pm"] },
      saturday: { available: false, timeSlots: [] },
      sunday: { available: false, timeSlots: [] },
    },
  },
  {
    id: 14,
    firstName: "Jennifer",
    lastName: "Martinez",
    phone: "+1 555-0130",
    profile: "https://i.pravatar.cc/150?img=19",
    country: "USA",
    city: "Chicago",
    professionalBackground: "Transformational coach helping individuals unlock their full potential.",
    coachingSince: "2013-02-28",
    createdAt: "2013-02-10",
    languages: ["English", "Spanish","Hindi","French"],   
    coachingSpecialities: ["Transformational Coaching", "Personal Development"],
    coachingAccreditation: ["ICF - PCC", "EMCC - EQA"],
    coachingInstitute: "Transformational Coaching Academy - Advanced Coaching Program",
    certificate: "https://example.com/certificates/jennifer-martinez-certificate.pdf",
    currency: "USD",
    minimumRate: 100,
    maximumRate: 200,
    availability: {
      monday: { available: true, timeSlots: ["10:00 am - 7:00 pm"] },
      tuesday: { available: false, timeSlots: [] },
      wednesday: { available: true, timeSlots: ["10:00 am - 7:00 pm"] },
      thursday: { available: false, timeSlots: [] },
      friday: { available: true, timeSlots: ["10:00 am - 7:00 pm"] },
      saturday: { available: false, timeSlots: [] },
      sunday: { available: false, timeSlots: [] },
    },
  },
  {
    id: 15,
    firstName: "Jennifer",
    lastName: "Martinez",
    phone: "+1 555-0130",
    profile: "https://i.pravatar.cc/150?img=19",
    country: "USA",
    city: "Chicago",
    professionalBackground: "Transformational coach helping individuals unlock their full potential.",
    coachingSince: "2013-02-28",
    createdAt: "2013-02-10",
    languages: ["English", "Spanish","Hindi","French"],         
    coachingSpecialities: ["Transformational Coaching", "Personal Development"],
    coachingAccreditation: ["ICF - PCC", "EMCC - EQA"],
    coachingInstitute: "Transformational Coaching Academy - Advanced Coaching Program",
    certificate: "https://example.com/certificates/jennifer-martinez-certificate.pdf",
       currency: "USD",
    minimumRate: 100,
    maximumRate: 200,
    availability: {
      monday: { available: true, timeSlots: ["10:00 am - 7:00 pm"] },
      tuesday: { available: false, timeSlots: [] },
      wednesday: { available: true, timeSlots: ["10:00 am - 7:00 pm"] },
      thursday: { available: false, timeSlots: [] },
      friday: { available: true, timeSlots: ["10:00 am - 7:00 pm"] },
      saturday: { available: false, timeSlots: [] },
      sunday: { available: false, timeSlots: [] },
    },
  },
  
];

// Language data
export const languageData = [
  { id: 1, name: "English", createdAt: "2023-01-15" },
  { id: 2, name: "Spanish", createdAt: "2023-01-16" },
  { id: 3, name: "Hindi", createdAt: "2023-01-17" },
  { id: 4, name: "French", createdAt: "2023-01-18" },
  { id: 5, name: "German", createdAt: "2023-01-19" },
  { id: 6, name: "Italian", createdAt: "2023-01-20" },
  { id: 7, name: "Portuguese", createdAt: "2023-01-21" },
  { id: 8, name: "Chinese", createdAt: "2023-01-22" },
  { id: 9, name: "Japanese", createdAt: "2023-01-23" },
  { id: 10, name: "Arabic", createdAt: "2023-01-24" },
  { id: 11, name: "Dutch", createdAt: "2023-01-25" },
  { id: 12, name: "Russian", createdAt: "2023-01-26" },
  { id: 13, name: "Turkish", createdAt: "2023-01-27" },
  { id: 14, name: "Polish", createdAt: "2023-01-28" },
  { id: 15, name: "Thai", createdAt: "2023-01-29" },
];

// Coaching Specialities data
export const coachingSpecialitiesData = [
  { id: 1, name: "Life Coaching", createdAt: "2023-02-01" },
  { id: 2, name: "Group Coaching", createdAt: "2023-02-02" },
  { id: 3, name: "Team Coaching", createdAt: "2023-02-03" },
  { id: 4, name: "Business Coaching", createdAt: "2023-02-04" },
  { id: 5, name: "Parental Coaching", createdAt: "2023-02-05" },
  { id: 6, name: "Mindset Coaching", createdAt: "2023-02-06" },
  { id: 7, name: "Relationship Coaching", createdAt: "2023-02-07" },
  { id: 8, name: "Executive Coaching", createdAt: "2023-02-08" },
  { id: 9, name: "Holistic Coaching", createdAt: "2023-02-09" },
  { id: 10, name: "Career Coaching", createdAt: "2023-02-10" },
  { id: 11, name: "Transformational Coaching", createdAt: "2023-02-11" },
  { id: 12, name: "Leadership Coaching", createdAt: "2023-02-12" },
  { id: 13, name: "Mindful Coaching", createdAt: "2023-02-13" },
  { id: 14, name: "Personal Development Coaching", createdAt: "2023-02-14" },
  { id: 15, name: "Performance Coaching", createdAt: "2023-02-15" },
];

// Coaching Accreditation data
export const coachingAccreditationData = [
  { id: 1, name: "ICF - ACC", createdAt: "2023-03-01" },
  { id: 2, name: "ICF - PCC", createdAt: "2023-03-02" },
  { id: 3, name: "APECS Accredited Executive Coach", createdAt: "2023-03-03" },
  { id: 4, name: "APECS Accredited Executive Team Coach", createdAt: "2023-03-04" },
  { id: 5, name: "ICF - MCC", createdAt: "2023-03-05" },
  { id: 6, name: "APECS Fellow", createdAt: "2023-03-06" },
  { id: 7, name: "EMCC - EIA", createdAt: "2023-03-07" },
  { id: 8, name: "APECS Practising Supervisor", createdAt: "2023-03-08" },
  { id: 9, name: "EMCC - EQA", createdAt: "2023-03-09" },
  { id: 10, name: "APECS Practising Executive Coach", createdAt: "2023-03-10" },
  { id: 11, name: "EMCC - ESIA", createdAt: "2023-03-11" },
  { id: 12, name: "APECS Practising Executive Team Coach", createdAt: "2023-03-12" },
  { id: 13, name: "EMCC - ESQA", createdAt: "2023-03-13" },
  { id: 14, name: "Degree - MA in Psychology (other)", createdAt: "2023-03-14" },
  { id: 15, name: "AC - Coach", createdAt: "2023-03-15" },
];

// Currency data
export const currencyData = [
  { id: 1, name: "Australian dollar (AUD)", createdAt: "2023-04-01" },
  { id: 2, name: "Canadian dollar (CAD)", createdAt: "2023-04-02" },
  { id: 3, name: "Chinese renminbi (CNH)", createdAt: "2023-04-03" },
  { id: 4, name: "Euro (EUR)", createdAt: "2023-04-04" },
  { id: 5, name: "Hong Kong dollar (HKD)", createdAt: "2023-04-05" },
  { id: 6, name: "Indian Rupee (INR)", createdAt: "2023-04-06" },
  { id: 7, name: "Japanese yen (JPY)", createdAt: "2023-04-07" },
  { id: 8, name: "New Zealand dollar (NZD)", createdAt: "2023-04-08" },
  { id: 9, name: "Pound sterling (GBP)", createdAt: "2023-04-09" },
  { id: 10, name: "Swiss franc (CHF)", createdAt: "2023-04-10" },
  { id: 11, name: "UAE Dirham (AED)", createdAt: "2023-04-11" },
  { id: 12, name: "US dollar (USD)", createdAt: "2023-04-12" },
  { id: 13, name: "Australian dollar (AUD)", createdAt: "2023-04-13" },
  { id: 14, name: "Hong Kong dollar (HKD)", createdAt: "2023-04-14" },
  { id: 15, name: "Indian Rupee (INR)", createdAt: "2023-04-15" },
];
  